module.exports = __webpack_public_path__ + "img/calendar-12.64fe1f87.svg";